<div class="card-container">
  <mat-card class="left-card">
    <mat-card-content class="card-content">
      <h1 class="advisor-title">Advisor</h1>
      <div class="advisor-select-container">
        <button
          class="filters-btn"
          mat-stroked-button
          (click)="openFilterModal()"
          [disabled]="!hasFilterOptions"
        >
          <mat-icon>list</mat-icon>
          <span class="spacer"></span>
          Filters ({{ filterCount }})
        </button>

        <mat-form-field color="accent" class="search-field">
          <mat-label>Select a collection</mat-label>
          <mat-select
            [(ngModel)]="selectedCollection"
            (selectionChange)="setCollection($event.value)"
          >
            <mat-option *ngFor="let option of collections" [value]="option">
              {{ option.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="mt-4">
        <mat-card class="preview-card">
          <div class="card-content-wrapper">
            <mat-card-content class="preview-content">
              <ng-container *ngIf="modelResponse; else promptLoadingAnimation">
                {{ modelResponse }}
              </ng-container>
              <ng-template #promptLoadingAnimation>
                <p *ngIf="promptLoading" class="loading-text">
                  <span class="ellipsis"></span>
                </p>
                <p *ngIf="!promptLoading" class="placeholder-text">
                  Prompt response will appear here...
                </p>
              </ng-template>
            </mat-card-content>
            <br /><br /><br />
            <div class="icon-buttons">
              <button
                mat-icon-button
                [matMenuTriggerFor]="modelMenu"
                color="accent"
                matTooltip="Change Model"
                *ngIf="modelResponse && promptFinished"
              >
                <mat-icon>auto_awesome</mat-icon>
              </button>
              <button
                mat-icon-button
                color="warn"
                matTooltip="Reset"
                *ngIf="modelResponse && promptFinished"
                (click)="clearPromptResult()"
              >
                <mat-icon>refresh</mat-icon>
              </button>
              <button
                mat-icon-button
                style="color: #1163fb"
                matTooltip="Draft"
                *ngIf="modelResponse && promptFinished"
                (click)="draftSection()"
              >
                <mat-icon>description</mat-icon>
              </button>
              <button
                mat-icon-button
                color="accent"
                matTooltip="Copy to clipboard"
                *ngIf="modelResponse && promptFinished"
                (click)="copyToClipboard()"
              >
                <mat-icon>content_copy</mat-icon>
              </button>

              <mat-menu
                #modelMenu="matMenu"
                xPosition="before"
                overlapTrigger="true"
                class="custom-menu"
              >
                <button
                  mat-menu-item
                  *ngFor="let model of models.modelList"
                  [disabled]="model === selectedModel"
                  (click)="selectModel(model)"
                  class="model-options"
                >
                  {{ model.name }}
                </button>
              </mat-menu>
            </div>
          </div>
        </mat-card>
      </div>

      <div class="prompt-container">
        <mat-form-field class="textarea-container" color="accent">
          <mat-label>Enter your prompt</mat-label>
          <mat-hint
            >Ask specific questions to the LLM with contextual answers from your
            document</mat-hint
          >

          <textarea
            matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            [(ngModel)]="prompt"
            [disabled]="promptInProgress"
            (keydown.enter)="runPrompt()"
            cdkAutosizeMinRows="1"
          ></textarea>
          <button
            mat-icon-button
            matSuffix
            (click)="runPrompt()"
            [disabled]="!prompt || promptInProgress"
            class="send-button"
          >
            <mat-icon>send</mat-icon>
          </button>
          <!-- <button mat-icon-button color="warn" matTooltip="Stop" *ngIf="promptInProgress" (click)="cancelPrompt()">
                <mat-icon>stop</mat-icon>
              </button> -->
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card class="right-card">
    <div *ngIf="sourceDocuments.length; else logDisplay">
      <h3 style="cursor: default">
        Source Information
        <mat-icon
          matTooltip="This section lists the context used from the collection of documents relevant to your prompt. Higher scores indicate higher relevance."
          aria-label="Information about source documents"
          class="info-icon"
        >
          info
        </mat-icon>
      </h3>
      <mat-card *ngFor="let doc of sourceDocuments">
        <mat-card-header (click)="openSourceDocumentDialog(doc)">
          <mat-card-title class="source-card">{{
            doc.metadata.title
          }}</mat-card-title>
          <mat-card-subtitle
            >Score: {{ doc.score | number : "1.2-2" }}</mat-card-subtitle
          >
        </mat-card-header>
      </mat-card>
    </div>
    <ng-template #logDisplay>
      <mat-card-header>
        <mat-card-title class="dark-title">
          Previous Questions
          <mat-icon
            matTooltip="This section displays a history of recent questions you asked. Click on any question to set it as the current query."
            aria-label="Information about previous questions"
            class="info-icon"
          >
            info
          </mat-icon>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="logsLoading" class="loading-container">
          <mat-spinner></mat-spinner>
        </div>
        <mat-list class="options-list" role="list" *ngIf="qaLogs.length">
          <mat-list-item
            role="listitem"
            *ngFor="let option of qaLogs"
            (click)="setQuestion(option.prompt)"
          >
            <small>{{ option.title }}</small>
          </mat-list-item>
        </mat-list>
        <p *ngIf="!qaLogs.length" class="dark-text">
          No previous questions available.
        </p>
      </mat-card-content>
    </ng-template>
  </mat-card>
</div>
